export const failedPayment = {
  title: {
    letsCompletePayment: 'Let’s complete your payment',
    sorryYourCardWasDeclined: 'Sorry, your card was declined',
    pleaseUpdateYourPaymentMethod: 'Please update your payment method',
    paymentReceived: 'Your payment has been received',
  },
  label: {
    paymentFailed: 'Payment Failed',
    missingPaymentMethod: 'Missing Payment Method',
    paymentIncomplete: 'Payment Incomplete',
    totalDue: 'Total Due',
    paid: 'Paid',
    notReady: 'Not ready to start your plan?',
    saveYourPlan: 'We’ll save your plan for whenever you’re ready to subscribe.',
    continueProgramPay: 'To continue your program, please make payment now.',
    updatePaymentContinue: 'Please update your payment method to continue your program.',
  },
  actions: {
    makePayment: 'Make Payment',
    update: 'Update',
    tryAgain: 'Try Again',
    callSupport: 'Call Support',
    comeBackLater: 'Come Back Later',
    completePayment: 'Complete Payment',
    pay: 'Pay',
  },
  errors: {
    failedToGetOrder: 'Failed to get order information',
    failedToInitiatePay: 'Failed to initiate payment',
    failedToProcessFlow: 'Failed to process flow',
  },
};
